import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("equinox@freedomcoreventures.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) nav("/", { replace: true });
  };

  return (
    <div className="equinox-bg min-h-screen flex items-center justify-center px-6 relative">
      <div className="absolute inset-0 pointer-events-none opacity-40"
           style={{
             background:
               "radial-gradient(50% 40% at 50% 50%, rgba(0,122,255,0.18), transparent 70%)",
           }}
      />
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-10">
          <img
            src="/equinox-logo-512.png"
            alt="Equinox"
            className="w-20 h-20 object-contain mx-auto mb-6 drop-shadow-[0_0_30px_rgba(0,122,255,0.55)]"
            data-testid="login-logo"
          />
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#007AFF]/80 mb-2">Equinox Systems</div>
          <h1 className="font-display text-4xl font-light tracking-tight text-white">Welcome back</h1>
          <p className="text-white/45 mt-2 text-sm">Sign in to your operating system</p>
        </div>

        <form
          onSubmit={submit}
          className="rounded-3xl p-8"
          style={{
            background: "rgba(255,255,255,0.03)",
            backdropFilter: "blur(28px)",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 24px 60px rgba(0,0,0,0.6)",
          }}
          data-testid="login-form"
        >
          <label className="block text-[10px] uppercase tracking-[0.25em] text-white/40 mb-2">Email</label>
          <input
            data-testid="login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            required
            className="w-full bg-black/40 border border-white/10 rounded-2xl px-4 py-3 text-white text-sm outline-none focus:border-[#007AFF]/50 focus:ring-1 focus:ring-[#007AFF]/40 mb-5 transition"
          />
          <label className="block text-[10px] uppercase tracking-[0.25em] text-white/40 mb-2">Password</label>
          <input
            data-testid="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
            className="w-full bg-black/40 border border-white/10 rounded-2xl px-4 py-3 text-white text-sm outline-none focus:border-[#007AFF]/50 focus:ring-1 focus:ring-[#007AFF]/40 mb-6 transition"
          />
          {error && (
            <div data-testid="login-error" className="text-rose-400 text-xs mb-4 px-1">{error}</div>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full bg-[#007AFF] hover:bg-[#0066CC] rounded-full py-3 text-sm font-medium text-white shadow-[0_0_24px_rgba(0,122,255,0.5)] hover:shadow-[0_0_32px_rgba(0,122,255,0.7)] transition-all disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="text-center text-[10px] text-white/30 mt-8 tracking-wider uppercase">
          Equinox OS · v1.0 · Internal
        </div>
      </div>
    </div>
  );
}
